 <template>
  <div class="container login" v-if="!$noCartMode()">
    <h1>{{ $t('login_header') }}</h1>

    <div 
      v-if="dbConfig.enable_phone_login"
      class="flex-row justify-space-between button-login-mode"
    >
      <button class="regular-font" :class="{'disabled': login_by_email}" @click="login_by_email=true">{{ $t('by_login') }}</button>
      <button class="regular-font" :class="{'disabled': !login_by_email}" @click="login_by_email=false">{{ $t('by_phone') }}</button>
    </div>
    
    <LoginUserNameForm v-if="login_by_email || !dbConfig.enable_phone_login" />
    <LoginPhoneForm v-if="!login_by_email && dbConfig.enable_phone_login" :db-config="dbConfig" />
  </div>
</template>

<script>
import LoginUserNameForm from '@/components/forms/login-username-form';
import LoginPhoneForm from '@/components/forms/login-phone-form';
import {DbConfig} from '@/models/db-config';

export default {
  components: {
    LoginUserNameForm,
    LoginPhoneForm,
  },

  data() {
    return {
      login_by_email: true,
      dbConfig: {},
    }
  },
  head() {
    return {
      title: this.$t('login'),
    }
  },
  mounted(){
    if(this.$noCartMode()){
      this.$nuxt.context.error({statusCode: 404});
      return
    }
  },
  async fetch() {
    this.dbConfig = await DbConfig.config({count_loading: true}).first();
  },
}
</script>

<style lang="scss">
  .button-login-mode{
    width: 380px;
    margin: 0 auto;
    margin-bottom: 10px;
    *{
      text-transform: none;
      font-size: 13px;
    }
  }
</style>

<i18n lang="yaml">
ru:
  login_header: 'Войдите в аккаунт'
  by_login: 'По имени пользователя'
  by_phone: 'По номеру телефона'
en:
  login_header: 'Login to your account'
  by_login: 'By user name'
  by_phone: 'By phone number'
</i18n>
